// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QIlDrb {
  flex: 1;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.dz24Ts {
  display: flex;
  flex-grow: 2;
  flex-direction: column;
  gap: var(--spacing-2, 16px);
  overflow-y: auto;
}

.AICKxj {
  padding: var(--spacing-3, 24px) 0 0;
  display: flex;
  flex-direction: row;
  gap: var(--spacing-2, 16px);
}

.LqOLCc {
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-regular, 400);
  color: var(--text-neutral-dark);
  line-height: var(--line-height-180);
}

.LWWHav {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/layouts/DrawerOperator/pages/RegisterType/RegisterType.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,OAAO;AACT","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n\n.info {\n  display: flex;\n  flex-grow: 2;\n  flex-direction: column;\n  gap: var(--spacing-2, 16px);\n  overflow-y: auto;\n}\n\n.footer {\n  padding: var(--spacing-3, 24px) 0 0;\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-2, 16px);\n}\n\n.description {\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-180);\n}\n\n.button {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `QIlDrb`,
	"info": `dz24Ts`,
	"footer": `AICKxj`,
	"description": `LqOLCc`,
	"button": `LWWHav`
};
module.exports = ___CSS_LOADER_EXPORT___;
